import { render, staticRenderFns } from "./client-details.vue?vue&type=template&id=30d2d325"
import script from "./client-details.vue?vue&type=script&lang=js"
export * from "./client-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports